// src/pages/playlists/usePlaylistToast.jsx
// Handoff toast: dark pill at the bottom, 2.6s (4.2s with Undo). Lifted above
// the audio BottomPlayer (.bp) when it's showing.
import { useCallback, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { PlsIc } from "./playlistIcons";

export function usePlaylistToast() {
  const [toast, setToast] = useState(null);
  const timer = useRef(null);
  useEffect(() => () => clearTimeout(timer.current), []);

  const show = useCallback((msg, action) => {
    setToast({ msg, action, key: Date.now(), lift: !!document.querySelector(".bp") });
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setToast(null), action ? 4200 : 2600);
  }, []);

  const node = toast
    ? createPortal(
        <div key={toast.key} className={`pls-toast-wrap pls-vars ${toast.lift ? "lift" : ""}`} onClick={(e) => e.stopPropagation()}>
          <div className="pls-toast" role="status">
            {PlsIc.check(15)}
            <span className="msg">{toast.msg}</span>
            {toast.action && (
              <button type="button" onClick={() => { toast.action.fn(); setToast(null); }}>
                {toast.action.label}
              </button>
            )}
          </div>
        </div>,
        document.body,
      )
    : null;

  return [node, show];
}
